import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackGaPageView } from "@/lib/ga";

/**
 * Dispara page_view do GA4 a cada mudança de rota (incluindo o primeiro
 * render). Sem isso, numa SPA o GA4 só mediria o primeiro carregamento.
 */
export const GaRouteTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    trackGaPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
};
